export default "__VITE_ASSET__d778aa17__"